import React, { PureComponent } from 'react';
import Helmet from 'react-helmet';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import { Header, Eyebrow } from 'formlabs-web-components/Type';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import Card from '../../../../common/components/content/Card';
import BlogPagination from './BlogPagination';
import { withTranslation } from 'react-i18next';
import './Blog.module.css';
const CustomerStoriesList = DisplayComponent(
  class CustomerStoriesList extends PureComponent {
    render() {
      const { posts, page, hasNext, hasPrev, path, t } = this.props;
      return (
        <Grid direction="x">
          {page > 1 ? (
            <Helmet>
              <link rel="canonical" href={`${path}/?page=${page}`} />
            </Helmet>
          ) : null}
          <Cell largeSize={24}>
            <div styleName="stories-header">
              <Header level={4} displayAs={4}>
                {t('Customer Stories')}
              </Header>
            </div>
          </Cell>
          <Cell largeSize={24}>
            <div styleName="posts">
              {posts.map(post => (
                <div key={`${post.title}${post.slug}`} styleName="post-wrapper">
                  <div styleName="post-sizing">
                    <Card
                      url={post.url}
                      imageConstraint="150px"
                      imagePosition="left"
                      bgColor="transparent-black"
                      image={post.listing_image}
                      padding="35px 0"
                      hover="light-grey"
                    >
                      <div styleName="post-eyebrows">
                        <Eyebrow color="blue">{post.type}</Eyebrow>
                      </div>
                      <Header level={4} displayAs={4} weight={400}>
                        {post.title}
                      </Header>
                    </Card>
                  </div>
                </div>
              ))}
            </div>
            <BlogPagination page={page} hasNext={hasNext} hasPrev={hasPrev} />
          </Cell>
        </Grid>
      );
    }
  }
);

CustomerStoriesList.propTypes = {};

export default withTranslation()(CustomerStoriesList);
